import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import environment from '@environments/environment';
import { LoadingService } from '@loader/spinner';
import { AuthActions } from '../auth/redux/auth.actions';

/** Reads `originalUri` before `handleRedirect` clears it, then redirects there. */
export const OktaLoginCallbackGuard: CanActivateFn = async () => {
  const oktaAuth: OktaAuth = inject(OKTA_AUTH);
  const router = inject(Router);
  const store = inject(Store);
  const loading = inject(LoadingService);

  const url = new URL(window.location.href);
  if (!url.searchParams.get('code') || !url.searchParams.get('state')) {
    window.location.href = environment.clinsphereUrl;
    return false;
  }

  loading.showLoading();
  const originalUri = oktaAuth.getOriginalUri();

  try {
    await oktaAuth.handleRedirect();
  } catch (err) {
    console.error('Error handling Okta redirect', err);
    store.dispatch(AuthActions.loginFailed({ error: err }));
    loading.hideLoading();
    return false;
  }

  store.dispatch(AuthActions.handleLoginRedirect());

  return router.parseUrl(
    originalUri && originalUri !== '/' ? originalUri : '/welcome',
  );
};
